import { render } from "./MakeAPayment.vue?vue&type=template&id=822f693c&scoped=true"
import script from "./MakeAPayment.vue?vue&type=script&lang=js"
export * from "./MakeAPayment.vue?vue&type=script&lang=js"

import "./MakeAPayment.vue?vue&type=style&index=0&id=822f693c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822f693c"]])

export default __exports__